import React from "react";
import {useNavigate} from "react-router";
import {Button} from "reactstrap";
import SafeView from "../../safeView/SafeView";
import "./back-styles.scss";

/** This component will go back one page with react router history */

const Back = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(-1);
  };

  return (
    <SafeView>
      <div className={"back_main"}>
        <Button className="back_btn roboto-bold" onClick={handleClick}>
          Back
        </Button>
      </div>
    </SafeView>
  );
};

export default Back;
